const standardVariants = (basePrice, labels = ["1 oz", "4 oz", "16 oz"]) => [
  { label: labels[0], price: Number(basePrice.toFixed(2)) },
  { label: labels[1], price: Number((basePrice * 1.45).toFixed(2)) },
  { label: labels[2], price: Number((basePrice * 1.9).toFixed(2)) },
];

const catalogSeed = [
  {
    name: "Hungarian Smoked Paprika",
    slug: "hungarian-smoked-paprika",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients", "sale"],
    price: 6.32,
    compareAtPrice: 7.25,
    rating: 4.9,
    reviews: 342,
    label: "Best seller",
    form: "Ground",
    heat: "Mild",
    origin: "Spain",
    taste: "Smoky, sweet and earthy",
    ingredients: "Smoked red peppers",
    tags: ["paprika", "smoky", "red pepper", "grilling"],
    blurb: "Oak-smoked red peppers create a deep brick color and a rounded, campfire-like aroma without overwhelming heat.",
    uses: "Stir it into stews, roasted vegetables, dry rubs, eggs or creamy sauces when a warm smoky finish is welcome.",
    atlas: 0,
    position: 0,
  },
  {
    name: "Ground Cumin",
    slug: "ground-cumin",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients"],
    price: 6.3,
    rating: 4.8,
    reviews: 284,
    label: "Pantry essential",
    form: "Ground",
    heat: "No heat",
    origin: "India",
    taste: "Warm, nutty and bittersweet",
    ingredients: "Cumin seeds",
    tags: ["cumin", "curry", "taco", "savory"],
    blurb: "Freshly milled cumin brings an unmistakable toasted warmth that anchors dishes from weeknight chili to slow-cooked curries.",
    uses: "Bloom a spoonful in oil, mix it into spice blends or add it to beans, rice, vegetables and grilled meats.",
    atlas: 0,
    position: 1,
  },
  {
    name: "Vietnamese Cinnamon",
    slug: "vietnamese-cinnamon",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 6.02,
    rating: 4.9,
    reviews: 318,
    label: "Top rated",
    form: "Ground",
    heat: "No heat",
    origin: "Vietnam",
    taste: "Sweet, bold and warmly spicy",
    ingredients: "Vietnamese cassia bark",
    tags: ["cinnamon", "baking", "coffee", "sweet"],
    blurb: "This vivid cinnamon has a concentrated fragrance and a confident warmth that stays present after baking.",
    uses: "Use it in rolls, cakes, oatmeal, hot drinks, spice blends and braised dishes that benefit from sweet warmth.",
    atlas: 0,
    position: 2,
  },
  {
    name: "Tellicherry Black Peppercorns",
    slug: "tellicherry-black-peppercorns",
    category: "Peppercorns",
    categorySlug: "peppercorns",
    collections: ["cooking-ingredients", "salt-pepper"],
    price: 6.74,
    rating: 4.9,
    reviews: 231,
    label: "Customer favorite",
    form: "Whole",
    heat: "Medium",
    origin: "India",
    taste: "Pungent, citrusy and woodsy",
    ingredients: "Black peppercorns",
    tags: ["pepper", "peppercorn", "whole", "grinder"],
    blurb: "Large, slowly ripened peppercorns deliver a fragrant crackle of citrus, wood and measured heat.",
    uses: "Grind them just before serving, crush them for steak rubs or simmer them whole in soups and pickling brines.",
    atlas: 0,
    position: 3,
  },
  {
    name: "Turmeric Root Powder",
    slug: "turmeric-root-powder",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 5.48,
    rating: 4.7,
    reviews: 196,
    label: "Golden staple",
    form: "Ground",
    heat: "No heat",
    origin: "India",
    taste: "Earthy, peppery and gently bitter",
    ingredients: "Turmeric root",
    tags: ["turmeric", "golden milk", "curry", "root"],
    blurb: "Finely ground turmeric adds a sunny golden color and an earthy backbone to savory and sweet recipes alike.",
    uses: "Whisk it into curries, rice, roasted vegetables, soups, smoothies or warm milk with ginger and black pepper.",
    atlas: 0,
    position: 4,
  },
  {
    name: "Roasted Garlic Granules",
    slug: "roasted-garlic-granules",
    category: "Seasonings",
    categorySlug: "seasonings",
    collections: ["cooking-ingredients", "spice-kits"],
    price: 5.84,
    rating: 4.8,
    reviews: 174,
    label: "Easy everyday flavor",
    form: "Granulated",
    heat: "No heat",
    origin: "United States",
    taste: "Toasty, mellow and savory",
    ingredients: "Roasted garlic",
    tags: ["garlic", "granulated", "roasted", "savory"],
    blurb: "Roasting softens garlic's sharp edge and gives these granules a mellow, almost nutty depth.",
    uses: "Shake them into marinades, pasta sauces, compound butter, vegetables or homemade seasoning blends.",
    atlas: 0,
    position: 5,
  },
  {
    name: "Yellow Mustard Seeds",
    slug: "yellow-mustard-seeds",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients"],
    price: 5.22,
    rating: 4.7,
    reviews: 128,
    label: "Pickling favorite",
    form: "Whole",
    heat: "Mild",
    origin: "Canada",
    taste: "Tangy, nutty and gently hot",
    ingredients: "Yellow mustard seeds",
    tags: ["mustard", "seed", "pickling", "whole"],
    blurb: "Whole yellow mustard seeds begin mild and nutty, then release a clean tang when crushed or soaked.",
    uses: "Add them to pickles, curries, braises and vinaigrettes, or grind them for a fresh mustard base.",
    atlas: 1,
    position: 0,
  },
  {
    name: "Dried Rosemary Leaves",
    slug: "dried-rosemary-leaves",
    category: "Herbs",
    categorySlug: "herbs",
    collections: ["cooking-ingredients"],
    price: 4.88,
    rating: 4.6,
    reviews: 145,
    label: "Aromatic herb",
    form: "Dried leaves",
    heat: "No heat",
    origin: "Morocco",
    taste: "Piney, woody and lemony",
    ingredients: "Rosemary leaves",
    tags: ["rosemary", "herb", "roast", "bread"],
    blurb: "Dried rosemary keeps its resinous, pine-like fragrance and stands up beautifully to long roasting.",
    uses: "Crush it over potatoes, focaccia, poultry, beans or vegetables and pair it with garlic and lemon.",
    atlas: 1,
    position: 1,
  },
  {
    name: "Green Cardamom Pods",
    slug: "green-cardamom-pods",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 8.95,
    rating: 4.9,
    reviews: 167,
    label: "Fragrant whole spice",
    form: "Whole pods",
    heat: "No heat",
    origin: "Guatemala",
    taste: "Floral, citrusy and cool",
    ingredients: "Green cardamom pods",
    tags: ["cardamom", "pod", "chai", "baking"],
    blurb: "Green cardamom pods hold tiny aromatic seeds with notes of eucalyptus, citrus and soft flowers.",
    uses: "Lightly crush the pods for chai, rice and braises, or grind the seeds for pastries and spice blends.",
    atlas: 1,
    position: 2,
  },
  {
    name: "Dried Orange Peel",
    slug: "dried-orange-peel",
    category: "Baking Ingredients",
    categorySlug: "baking-ingredients",
    collections: ["baking-ingredients", "cooking-ingredients"],
    price: 5.64,
    rating: 4.6,
    reviews: 112,
    label: "Bright citrus",
    form: "Diced",
    heat: "No heat",
    origin: "United States",
    taste: "Bright, bittersweet and citrusy",
    ingredients: "Orange peel",
    tags: ["orange", "citrus", "baking", "tea"],
    blurb: "Slow-dried orange peel offers concentrated citrus aroma with a pleasantly bittersweet edge.",
    uses: "Steep it in tea, simmer it in syrups, fold it into baked goods or add it to savory spice rubs.",
    atlas: 1,
    position: 3,
  },
  {
    name: "Deep Red Chili Powder",
    slug: "deep-red-chili-powder",
    category: "Dried Chiles",
    categorySlug: "dried-chiles",
    collections: ["cooking-ingredients", "sale"],
    price: 5.92,
    compareAtPrice: 6.65,
    rating: 4.8,
    reviews: 208,
    label: "On sale",
    form: "Ground blend",
    heat: "Medium",
    origin: "United States",
    taste: "Warm, earthy and rounded",
    ingredients: "Dried chiles, cumin, garlic and oregano",
    tags: ["chili", "powder", "tex mex", "blend"],
    blurb: "A balanced ground chile blend brings steady warmth, deep red color and savory spice without harsh heat.",
    uses: "Build chili, tacos, beans, roasted corn, barbecue rubs and tomato sauces with a spoonful or two.",
    atlas: 1,
    position: 4,
  },
  {
    name: "Crushed Sumac",
    slug: "crushed-sumac",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients"],
    price: 6.58,
    rating: 4.7,
    reviews: 136,
    label: "Tangy favorite",
    form: "Crushed",
    heat: "No heat",
    origin: "Turkey",
    taste: "Tart, fruity and lightly earthy",
    ingredients: "Sumac berries",
    tags: ["sumac", "tangy", "middle eastern", "berry"],
    blurb: "Crushed sumac berries add a vivid burgundy color and a clean lemon-like tang without extra liquid.",
    uses: "Dust it over hummus, salads, grilled meat, roasted vegetables, flatbreads or yogurt sauces.",
    atlas: 1,
    position: 5,
  },
  {
    name: "Saffron Threads",
    slug: "saffron-threads",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 12.9,
    rating: 4.9,
    reviews: 94,
    label: "Small-batch select",
    form: "Whole threads",
    heat: "No heat",
    origin: "Spain",
    taste: "Floral, honeyed and hay-like",
    ingredients: "Saffron threads",
    tags: ["saffron", "thread", "paella", "rice"],
    blurb: "A small pinch of vivid saffron threads releases a distinctive floral aroma and deep golden hue.",
    uses: "Bloom the threads in warm water or milk before adding them to rice, seafood, breads and custards.",
    variants: [
      { label: "0.25 oz", price: 12.9 },
      { label: "0.5 oz", price: 23.8 },
      { label: "1 oz", price: 43.5 },
    ],
    atlas: 2,
    position: 0,
  },
  {
    name: "Greek Oregano",
    slug: "greek-oregano",
    category: "Herbs",
    categorySlug: "herbs",
    collections: ["cooking-ingredients"],
    price: 5.25,
    rating: 4.7,
    reviews: 153,
    label: "Mediterranean staple",
    form: "Dried leaves",
    heat: "No heat",
    origin: "Greece",
    taste: "Peppery, green and lightly bitter",
    ingredients: "Oregano leaves",
    tags: ["oregano", "herb", "greek", "mediterranean"],
    blurb: "Greek oregano is robust and peppery, with a green fragrance that remains clear in tomato-rich dishes.",
    uses: "Rub it between your palms over pizza, grilled vegetables, lamb, chicken, salad dressing and beans.",
    atlas: 2,
    position: 1,
  },
  {
    name: "Toasted Onion Powder",
    slug: "toasted-onion-powder",
    category: "Seasonings",
    categorySlug: "seasonings",
    collections: ["cooking-ingredients", "spice-kits"],
    price: 5.46,
    rating: 4.6,
    reviews: 121,
    label: "Savory shortcut",
    form: "Ground",
    heat: "No heat",
    origin: "United States",
    taste: "Sweet, roasted and savory",
    ingredients: "Toasted onion",
    tags: ["onion", "powder", "toasted", "seasoning"],
    blurb: "Toasted onion powder folds rich caramelized flavor into recipes without chopping or extra moisture.",
    uses: "Blend it into dips, soups, burger seasoning, gravy, sauces and crunchy snack coatings.",
    atlas: 2,
    position: 2,
  },
  {
    name: "Himalayan Pink Salt",
    slug: "himalayan-pink-salt",
    category: "Sea Salts",
    categorySlug: "sea-salts",
    collections: ["cooking-ingredients", "salt-pepper"],
    price: 5.6,
    rating: 4.8,
    reviews: 187,
    label: "Mineral-rich color",
    form: "Coarse crystals",
    heat: "No heat",
    origin: "Pakistan",
    taste: "Clean, mineral and gently saline",
    ingredients: "Pink rock salt",
    tags: ["salt", "pink", "crystal", "grinder"],
    blurb: "Naturally pink crystals bring clean salinity and a delicate mineral character to everyday cooking.",
    uses: "Fill a salt mill, season roasting trays or crush a few crystals for a colorful finishing touch.",
    atlas: 2,
    position: 3,
  },
  {
    name: "Whole Star Anise",
    slug: "whole-star-anise",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 6.85,
    rating: 4.8,
    reviews: 109,
    label: "Whole aromatic",
    form: "Whole pods",
    heat: "No heat",
    origin: "Vietnam",
    taste: "Licorice-like, sweet and warm",
    ingredients: "Star anise",
    tags: ["anise", "whole", "pho", "baking"],
    blurb: "Star-shaped pods release a focused licorice aroma with sweet, warming spice underneath.",
    uses: "Simmer whole pods in broth, poaching liquid, mulled drinks and braises, then remove before serving.",
    atlas: 2,
    position: 4,
  },
  {
    name: "Ground Ginger",
    slug: "ground-ginger",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients", "baking-ingredients"],
    price: 5.18,
    rating: 4.7,
    reviews: 219,
    label: "Baking favorite",
    form: "Ground",
    heat: "Mild",
    origin: "India",
    taste: "Zesty, warm and citrusy",
    ingredients: "Ginger root",
    tags: ["ginger", "ground", "baking", "root"],
    blurb: "Ground ginger delivers bright root fragrance and a steady warming bite in a shelf-stable form.",
    uses: "Add it to cookies, cakes, curries, marinades, tea blends and roasted winter vegetables.",
    atlas: 2,
    position: 5,
  },
  {
    name: "Applewood Smoked Sea Salt",
    slug: "applewood-smoked-sea-salt",
    category: "Sea Salts",
    categorySlug: "sea-salts",
    collections: ["cooking-ingredients", "salt-pepper", "sale"],
    price: 6.25,
    compareAtPrice: 7.1,
    rating: 4.8,
    reviews: 142,
    label: "On sale",
    form: "Coarse crystals",
    heat: "No heat",
    origin: "United States",
    taste: "Smoky, clean and gently sweet",
    ingredients: "Sea salt, natural applewood smoke",
    tags: ["salt", "smoked", "applewood", "grilling"],
    blurb: "Slow applewood smoke settles into coarse sea salt for a clean, gently sweet campfire note.",
    uses: "Finish grilled vegetables, eggs, potatoes, fish or plant-based dishes with just a small pinch.",
    atlas: 3,
    position: 0,
  },
  {
    name: "Whole Coriander Seeds",
    slug: "whole-coriander-seeds",
    category: "Spices",
    categorySlug: "spices",
    collections: ["cooking-ingredients"],
    price: 5.12,
    rating: 4.6,
    reviews: 118,
    label: "Toasting spice",
    form: "Whole seeds",
    heat: "No heat",
    origin: "India",
    taste: "Citrusy, floral and nutty",
    ingredients: "Coriander seeds",
    tags: ["coriander", "seed", "citrus", "whole"],
    blurb: "Whole coriander seeds open with a light citrus scent and become rounder and nuttier after toasting.",
    uses: "Crush them for curries and rubs, add them whole to pickles or toast and grind them fresh.",
    atlas: 3,
    position: 1,
  },
  {
    name: "Turkish Bay Leaves",
    slug: "turkish-bay-leaves",
    category: "Herbs",
    categorySlug: "herbs",
    collections: ["cooking-ingredients"],
    price: 4.95,
    rating: 4.7,
    reviews: 133,
    label: "Slow-cook essential",
    form: "Whole leaves",
    heat: "No heat",
    origin: "Turkey",
    taste: "Herbal, tea-like and softly mentholated",
    ingredients: "Bay leaves",
    tags: ["bay leaf", "herb", "soup", "whole"],
    blurb: "Thin, fragrant bay leaves slowly infuse broth and sauce with an herbal, tea-like complexity.",
    uses: "Add one or two leaves to soups, beans, rice and braises, then remove them before serving.",
    atlas: 3,
    position: 2,
  },
  {
    name: "Golden Curry Powder",
    slug: "golden-curry-powder",
    category: "Seasonings",
    categorySlug: "seasonings",
    collections: ["cooking-ingredients", "spice-kits"],
    price: 6.4,
    rating: 4.8,
    reviews: 201,
    label: "House blend",
    form: "Ground blend",
    heat: "Mild",
    origin: "Blended in the United States",
    taste: "Warm, earthy and aromatic",
    ingredients: "Turmeric, coriander, cumin, fenugreek, ginger and spices",
    tags: ["curry", "blend", "golden", "seasoning"],
    blurb: "A balanced golden blend layers earthy turmeric, citrusy coriander and toasted cumin with gentle warmth.",
    uses: "Bloom it in oil for curries, stir it into lentils and soups or whisk it into yogurt marinades.",
    atlas: 3,
    position: 3,
  },
  {
    name: "Chipotle Pepper Flakes",
    slug: "chipotle-pepper-flakes",
    category: "Dried Chiles",
    categorySlug: "dried-chiles",
    collections: ["cooking-ingredients"],
    price: 7.1,
    rating: 4.7,
    reviews: 154,
    label: "Smoky heat",
    form: "Crushed flakes",
    heat: "Hot",
    origin: "Mexico",
    taste: "Smoky, fruity and hot",
    ingredients: "Smoked jalapeño peppers",
    tags: ["chipotle", "chile", "flakes", "hot"],
    blurb: "Crushed smoked jalapeños combine raisin-like fruitiness, campfire aroma and a direct but manageable heat.",
    uses: "Sprinkle the flakes over tacos, pizza, eggs and roasted squash or simmer them into sauces and beans.",
    atlas: 3,
    position: 4,
  },
  {
    name: "Porcini Mushroom Powder",
    slug: "porcini-mushroom-powder",
    category: "Mushrooms",
    categorySlug: "mushrooms",
    collections: ["cooking-ingredients"],
    price: 9.8,
    rating: 4.9,
    reviews: 176,
    label: "Umami boost",
    form: "Ground",
    heat: "No heat",
    origin: "European Union",
    taste: "Deep, woodsy and savory",
    ingredients: "Dried porcini mushrooms",
    tags: ["porcini", "mushroom", "umami", "powder"],
    blurb: "Finely ground porcini mushrooms dissolve into dishes and add concentrated woodland savoriness without extra texture.",
    uses: "Whisk it into risotto, gravy, soup, pasta sauce, burger seasoning or a finishing salt blend.",
    variants: standardVariants(9.8, ["1 oz", "2 oz", "4 oz"]),
    atlas: 3,
    position: 5,
  },
  {
    name: "Whole Sichuan Peppercorns",
    slug: "whole-sichuan-peppercorns",
    category: "Peppercorns",
    categorySlug: "peppercorns",
    collections: ["cooking-ingredients", "salt-pepper"],
    price: 7.45,
    rating: 4.8,
    reviews: 139,
    label: "Bright citrus heat",
    form: "Whole husks",
    heat: "Medium",
    origin: "Packed in Hong Kong",
    taste: "Citrusy, floral and gently numbing",
    ingredients: "Whole Sichuan peppercorn husks",
    tags: ["sichuan", "peppercorn", "whole", "mala"],
    blurb: "Fragrant reddish husks bring lively citrus aroma and a clean, tingling warmth to savory dishes.",
    uses: "Toast lightly before grinding for stir-fries, noodle sauces, braises, roasted vegetables and seasoning blends.",
  },
];

const productData = catalogSeed.map((item, index) => {
  const price = Number(Math.min(92, 45 + item.price * 4).toFixed(2));
  const variantLabels = item.variants?.map((variant) => variant.label);
  const variants = standardVariants(price, variantLabels);
  const image = `/images/products/items/${item.slug}.png`;
  const packaging = ["Resealable pouch", "Glass jar"];

  return {
    id: index + 1,
    sku: `SZ-${String(index + 1).padStart(3, "0")}`,
    brand: "sickzuno",
    name: item.name,
    slug: item.slug,
    category: item.category,
    categorySlug: item.categorySlug,
    collections: item.collections,
    price,
    compareAtPrice: item.compareAtPrice
      ? Number(Math.min(180, price * 1.12).toFixed(2))
      : null,
    rating: item.rating,
    reviews: item.reviews,
    label: item.label,
    tags: item.tags,
    heat: item.heat,
    dietary: ["All Natural", "Gluten-Free", "Non-GMO"],
    origin: "Packed in Hong Kong",
    taste: item.taste,
    ingredients: item.ingredients,
    material: item.ingredients,
    form: item.form,
    inStock: true,
    featured: item.rating >= 4.8,
    variants,
    packaging,
    size: variants.map((variant) => variant.label),
    colors: packaging,
    image,
    images: [image],
    imagePosition: "center",
    imageSize: "cover",
    description: [item.blurb, item.uses],
    Features: [
      `${item.form} culinary ingredient`,
      "Selected and packed in Hong Kong",
      "Packed in small batches for freshness",
      "Store sealed in a cool, dry place",
    ],
  };
});

export default productData;
